<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <v-switch
                    v-model="otherSettings.showTotalRow"
                    :change="change()">
                    <template v-slot:label>
                        <v-tooltip color="black" bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <span
                                v-bind="attrs"
                                v-on="on">Sticky Total Row</span>
                            </template>
                            Have total row stick to the bottom as you scroll
                        </v-tooltip>
                    </template>
                </v-switch>
                <v-switch
                    v-model="otherSettings.hideModalAfterSubmit"
                    :change="change()">
                    <template v-slot:label>
                        <v-tooltip color="black" bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <span
                                v-bind="attrs"
                                v-on="on">Collapse Pop-up After Submit</span>
                            </template>
                            After submiting forecast, close forecast window
                        </v-tooltip>
                    </template>
                </v-switch>
                <v-switch
                    v-model="otherSettings.speedRound"
                    :change="change()">
                    <template v-slot:label>
                        <v-tooltip color="black" bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <span
                                v-bind="attrs"
                                v-on="on">Speed Round</span>
                            </template>
                            only show input forecast when clicking of forecast month and product
                        </v-tooltip>
                    </template>
                </v-switch>
            </v-col>
            <v-col>
                <v-switch
                    v-model="otherSettings.saveOnMonthChange"
                    :change="change()">
                    <template v-slot:label>
                        <v-tooltip color="black" bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <span
                                v-bind="attrs"
                                v-on="on">Auto Save on Month Change</span>
                            </template>
                            Automatically save changes when switching months or products
                        </v-tooltip>
                    </template>
                </v-switch>
                <v-switch
                    v-model="otherSettings.hideInactiveProducts"
                    :change="change()">
                    <template v-slot:label>
                        <v-tooltip color="black" bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <span
                                v-bind="attrs"
                                v-on="on">Hide Inactive Products</span>
                            </template>
                            Hides all the inactive products from view
                        </v-tooltip>
                    </template>
                </v-switch>
                <v-switch
                    v-model="otherSettings.specificForecastProducts"
                    :change="change()">
                    <template v-slot:label>
                        <v-tooltip color="black" bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <span
                                v-bind="attrs"
                                v-on="on">Filter Category Specific Products</span>
                            </template>
                            Only show products that are specfic for that category. I.e. Tiny Tents
                        </v-tooltip>
                    </template>
                </v-switch>
            </v-col>
        </v-row>
        <v-row class="d-flex justify-center align-center">
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        @click="notifyNellie()"
                        color="primary">
                        <img width="25px" src="@/assets/nellie.jpg"/>
                        Notify Nellie
                    </v-btn>
                </template>
                <span>Do you dare poke Nellie...</span>
            </v-tooltip>
        </v-row>
        <v-snackbar
			v-model="snackbar"
			:timeout="timeout"
			:color="snackColor">
				{{ snackText}}
			<!-- dismiss button -->
			<template v-slot:action="{ attrs }">
				<v-btn
					v-bind="attrs"
					text
					@click="snackbar = false"
				>
					Close
				</v-btn>
			</template>
		</v-snackbar>
    </v-container>
</template>

<script>
export default {
    name: 'Settings',
    beforeMount() {
        if(localStorage.otherSettings) {
            this.otherSettings = JSON.parse(localStorage.otherSettings)
        } else {
            localStorage.otherSettings = JSON.stringify(this.otherSettings)
        }
        this.change()
    },
    data() {
        return {
            otherSettings: {
                showTotalRow: true,
                hideModalAfterSubmit: true,
                speedRound: false,
                saveOnMonthChange: true,
                hideInactiveProducts: false,
                specificForecastProducts: true,
            },
            snackbar: false,
			snackColor: '',
			snackText: '',
			timeout: 3000,
        }
    },
    methods: {
        change() {
            localStorage.otherSettings = JSON.stringify(this.otherSettings)
            this.$store.dispatch('updateOtherSettings', this.otherSettings)
        },
        notifyNellie() {
            const url = 'https://ww62v3jt5m.execute-api.us-east-2.amazonaws.com/prod/actions/notifynellie'
            const data = {
                'user': localStorage.username,
                'category': JSON.parse(localStorage.category).Forecast_Name
            }
            const request = {
                method: 'POST',
                headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(data),
            }
            fetch(url,request).then(async response => {
                const data = await response.json();
				if (!response.ok) {
					const error = (data && data.message) || response.status
					return Promise.reject(error)
				}
                this.snackbar = true
                this.snackColor = 'success'
                this.snackText = 'Nellie Has Been Poked'
            }).catch(error => {
                this.snackbar = true
                this.snackColor = 'error'
                this.snackText = error
            })
        }
    }
}
</script>

